import PropTypes from "prop-types";
import React from "react";
import styles from "./EventTicketsInfo.module.css";
import TrendUp from "./Images/TrendUp.svg";
import TrendFlat from "./Images/TrendsFlat.svg";
import TrendDown from "./Images/TrendDown.svg";
import { useTranslation } from "react-i18next";

export const EventTicketsInfo = ({
  name,
  trend,
  bTotal,
  bPaid,
  bVIP,
  bComp,
  pTotal,
  pPaid,
  pVIP,
  pComp,
  inPerson,
  virtual,
}) => {
  const trendColors = {
    up: "#43BA32",
    same: "#FF9A00",
    down: "#ED1F24",
  };
  const {t} = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.name}>{name}</div>
        <img
          src={
            trend == "up"
              ? TrendUp
              : trend == "same"
              ? TrendFlat
              : trend == "down"
              ? TrendDown
              : ""
          }
        />
      </div>
      <div className={styles.info}>
        <div>
          {t("Businesses:")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[bTotal.trend],
            }}
          >
            {bTotal.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("Paid:")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[bPaid.trend],
            }}
          >
            {bPaid.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("VIP")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[bVIP.trend],
            }}
          >
            {bVIP.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("Comp:")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[bComp.trend],
            }}
          >
            {bComp.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
      </div>

      <div className={styles.info}>
        <div>
          {t("People")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[pTotal.trend],
            }}
          >
            {pTotal.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("Paid:")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[pPaid.trend],
            }}
          >
            {pPaid.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("VIP")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[pVIP.trend],
            }}
          >
            {pVIP.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("Comp:")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[pComp.trend],
            }}
          >
            {pComp.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
      </div>

      <div className={styles.info2}>
        <div>
          {t("In-Person")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[inPerson.trend],
            }}
          >
            {inPerson.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
        <div>
          {t("Virtual")}{" "}
          <span
            className={styles.item}
            style={{
              color: trendColors[virtual.trend],
            }}
          >
            {virtual.value ?? "N/A"}
          </span>
          &nbsp;
        </div>
      </div>
    </div>
  );
};

EventTicketsInfo.propTypes = {};
